<template>
  <div>
    <edit-cloud-banking-institution
      :is-active.sync="isAdding"
      method="post"
      :institutions.sync="institutions"
      :cloudBankingInstitutionDialog="isAdding"
      @changed="cloudBankingInstitutionAdded"
    />
    <edit-cloud-banking-institution
      :is-active.sync="isUpdating"
      method="put"
      :cloudBankingInstitution.sync="cloudBankingInstitution"
      :institutions.sync="institutions"
      :cloudBankingInstitutionDialog="isUpdating"
      @changed="cloudBankingInstitutionUpdated"
    />
    <data-table
      :title="provider"
      ref="table"
      :url="url"
      :headers="headers"
      @click="editInstitution"
    >
      <template slot="action.icons" v-if="provider === 'danapay' || provider === 'Neero'">
        <v-btn color="primary" @click="isAdding = true">
          <v-icon color="light-blue lighten-4">
            mdi-plus-outline
          </v-icon>
          Add Institution
        </v-btn>
      </template>
      <template slot="item.is_active" slot-scope="{ item }">
        <v-icon color="success" v-if="item.is_active">mdi-progress-check</v-icon>
        <v-icon color="warning" v-else>mdi-information-outline</v-icon>
      </template>
      <template v-slot:item.institution_id="{ item }">
        <v-select
          label="Select"
          :items="filteredInstitution(item)"
          variant="solo"
          item-text="label"
          item-value="id"
          v-model="item.institution"
          :hint="`${item.institution.type}`"
          persistent-hint
          return-object
          single-line
          v-on:change="(e) => saveInstitution(e, item)"
        ></v-select>
      </template>
      <template v-slot:item.actions="{ item }">
        <div class="d-flex">
          <v-btn
            v-if="item.provider === 'danapay' || item.provider === 'Neero'"
            icon
            @click="editInstitution(item)"
          >
            <v-icon>mdi-pencil</v-icon>
          </v-btn>
          <v-icon
            v-if="item.provider === 'danapay' || item.provider === 'Neero'"
            @click="deleteInstitution(item)"
          >
            mdi-delete
          </v-icon>
        </div>
      </template>
    </data-table>
  </div>
</template>

<script>
import EditCloudBankingInstitution from "../platformConfigurations/cloudBankingInstitution/form";

export default {
  components: { EditCloudBankingInstitution },

  data() {
    return {
      isAdding: false,
      isUpdating: false,
      cloudBankingInstitution: {},
      currentFilter: "all",
      url: `api/v1/${this.$route.params.id}/institutions`,
      headers: this.pairTableLabelWithValue({
        ID: "id",
        Name: "name",
        Type: "institution.type",
        Country: "country",
        Currency: "currency",
        "Common label": "institution_id",
        Actions: "actions",
      }),
      institutions: [],
    };
  },
  watch: {
    url() {
      this.$nextTick(() => {
        this.$refs.table.fetchData();
      });
    },
  },
  methods: {
    filteredInstitution(item) {
      return this.institutions.filter((it) => it.type === item.institution.type);
    },
    saveInstitution(e, institution) {
      this.$http
        .put(`/api/v1/${this.$route.params.id}/institutions/` + institution.id, {
          institution_id: e.id,
        })
        .then(() => {
          Notify.success("Institution was updated successfully");
        });
    },
    cloudBankingInstitutionAdded() {
      this.isAdding = false;
      this.$refs.table.fetchData();
    },
    cloudBankingInstitutionUpdated({ message }) {
      this.cloudBankingInstitution = null;
      this.isUpdating = false;
      Notify.success(message);
      this.$refs.table.fetchData();
    },
    editInstitution(item) {
      this.cloudBankingInstitution = { ...item, type: item.institution.type };
      this.isUpdating = true;
    },
    deleteInstitution(item) {
      window.Notify.confirm("This will delete the entry permanently from the database").then(() => {
        this.$http
          .delete(`api/v1/${this.$route.params.id}/institutions/${item.id}`)
          .then(() => this.$refs.table.fetchData())
          .catch((response) => window.Notify.errorFromResponse(response));
      });
    },
  },
  computed: {
    provider() {
      return this.$route.params.id;
    },
  },
  created() {
    this.$http
      .get("/api/v1/danapay-institutions")
      .then((response) => (this.institutions = response));
    this.$watch(
      () => this.$route.params,
      () => {
        this.url = `api/v1/${this.$route.params.id}/institutions`;
      },
      { immediate: true },
    );
  },
};
</script>
